import React, { memo } from 'react'

//Components.
import ChallengeCoverCard from '../../card-component/challenge-card-component/ChallengeCoverCard';

//Dependencies.
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
//Functions.
  //Slice.
  import { allUpcomingChallenges } from '../../../slices/challengesSlice';

import './ChallengeAnnouncementsComponent.styles.css';


const ChallengeAnnouncementsComponent = () => {
  const allChallengeAnnouncements = useSelector(allUpcomingChallenges);
  const params = useParams();
  console.log(params)
  const navigate = useNavigate("/");

  if (params.filterBy === "all") {
    const coverCardContainerVariants = {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1,
        transition: {
          when: 'beforeChildren',
          staggerChildren: 0.5
        }
      }
    }
  
    const coverCardVariants = {
      initial: {
        opacity: 0,
        y: -100
      },
      animate: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.33,
          damping: 9,
          stiffness: 505,
          type: "spring"
        }
      }
    }
  
    function handleCoverCardClick(val) {
      console.log(`${val._challengeID} has been clicked!!!`);
      navigate(`../details/announcement/${val._challengeID}`);
    }

    const {
      coverImageDetails: { imageLink },
      upcomingChallengeProperties: {
        daysRemainingBeforeAnnouncementEnds,
        challengeAnnouncementHeadline,
        challengeAnnouncementEndDate
      }
    } = Object.values(allChallengeAnnouncements)[0];  
  
    return (
      <motion.div
        className='challengeAnnouncementsContainer'
        variants={coverCardContainerVariants}
        initial="initial"
        animate="animate"
      >
        {
          Object.values(allChallengeAnnouncements).map(val => {
            return (
              <motion.div
                variants={coverCardVariants}
                whileHover={{ scale: 1.05 }}
                className='p-0 m-3'
                onClick={() => handleCoverCardClick(val)}
                key={val._challengeID}
              >
                <ChallengeCoverCard key={val._challengeID} {...val}/>
              </motion.div>            
            )
          })
        }
      </motion.div>
    )
  }

  else if (params.filterBy === "currentUser") {
    const coverCardContainerVariants = {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1,
        transition: {
          when: 'beforeChildren',
          staggerChildren: 1.25
        }
      }
    }
  
    const coverCardVariants = {
      initial: {
        opacity: 0,
        y: -100
      },
      animate: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.33,
          damping: 9,
          stiffness: 505
        }
      }
    }
  
    function handleCoverCardClick(val) {
      navigate(`../details/announcement/${val._challengeID}`);
    }

    const {
      coverImageDetails: { imageLink },
      upcomingChallengeProperties: {
        daysRemainingBeforeAnnouncementEnds,
        challengeAnnouncementHeadline,
        challengeAnnouncementEndDate
      }
    } = Object.values(allChallengeAnnouncements)[0];  
  
    return (
      <motion.div className='challengeAnnouncementsContainer' variants={coverCardContainerVariants} initial="initial" animate="animate">
        {
          Object.values(allChallengeAnnouncements)
            .filter(announcement => announcement._ownerID == params._userID)
            .map(val => {
            return (
              <motion.div
                variants={coverCardVariants}
                whileHover={{ border: "7.5px solid lightseagreen", borderRadius: "15px", scale: 1.05 }}
                className='p-0 m-3'
                onClick={() => handleCoverCardClick(val)} key={val._challengeID}
              >
                <ChallengeCoverCard {...val}/>
              </motion.div>            
            )
          })
        }
      </motion.div>
    )
  }

  else {
    return (
      <h1>Unable to filter by <span className='text-danger'>{params.filterBy}</span>.</h1>
    )
  }
}

export default memo(ChallengeAnnouncementsComponent);